import * as React from 'react';
import Button from '@doordash/component-button';
import { InlineChildren, Stack } from '@doordash/design-language';
import TestIds from './TestIds';
var ButtonGroupModalFooter = function (_a) {
    var primary = _a.primary, secondary = _a.secondary;
    return (React.createElement(React.Fragment, null,
        React.createElement(Stack, null),
        React.createElement(InlineChildren, { alignItems: InlineChildren.Alignment.Center, justifyContent: InlineChildren.Justification.FlexEnd },
            React.createElement(React.Fragment, null,
                React.createElement(InlineChildren, { alignItems: InlineChildren.Alignment.Center },
                    secondary && (React.createElement(Button, { type: Button.Types.TertiaryPill, onClick: secondary.action, disabled: secondary.disabled, state: secondary.loading
                            ? Button.States.Loading
                            : Button.States.Default }, secondary.text)),
                    React.createElement(Button, { "data-testid": TestIds.MODAL_FOOTER_BUTTON_PRIMARY, type: Button.Types.PrimaryPill, onClick: primary.action, isDisabled: primary.disabled, state: primary.loading ? Button.States.Loading : Button.States.Default }, primary.text))))));
};
export default ButtonGroupModalFooter;
